import {createApp} from 'vue';

import NewsPage from './layout';

const app = createApp({
  components: {
    'news-page': NewsPage
  }
}).mount('#articles-news');


window.newsIndex = function (_data) {
  "use strict";
  window.data = _data;
}
